import { Form, InputGroup, FormControlProps } from 'react-bootstrap';
import { BiSearch } from 'react-icons/bi';
import './styles.css';

interface Props extends FormControlProps {
  name: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

function SearchTalentInput({ inputRef, ...props }: Props) {
  return (
    <InputGroup>
      <InputGroup.Text className="search-input">
        <BiSearch size={22} />
      </InputGroup.Text>
      <Form.Control className="search-input" ref={inputRef} {...props} />
    </InputGroup>
  );
}

export default SearchTalentInput;
